import {
  BG_DETAIL_STATS,
  CITIZEN_STATS,
  CLEAR_SOS_API_HIT,
  EMERGENCY_STATS,
  GET_ACCOUNTS,
  INVENTORY_STATS,
  MANUFACTURE_STATS,
  OFFLINE_INTIMATION_STATS,
  OTHER_ALERTS_STATS,
  REFRESH_BTN_MONITOR,
  FILTER_BTN_VALUE,
  RTO_STATEID_STATS,
  TICKET_STATS,
  TOTAL_DEVICE_CLICK,
  VEHICLE_TYPE_WISE_STATS,
  VLTD_DAILY_STATS,
  VLTD_MONTHLY_STATS,
  VLTD_STATUS_STATS,
  RTO_STATS,
  VLTD_STATS_DASHBOARD,
  CITIZEN_USERS,
  CITIZEN_USERS_SOS,
  CITIZEN_ALERT_SOS,
  CITIZEN_USERS_SOS_FILTER,
  GET_ROUTEFENCE,
  GET_ROUTEFENCE_FILTER,
  GET_AREAFENCE,
  MONITOR_DASHBOARD_STATS,
  MONITOR_DASHBOARD_DETAIL,
  SOS_PROVIDER_BY_LOCATION,
  LOCATE_TRAUMACENTER,
  GET_RTO_RFC,
  EMERGENCY_DASHBOARD_DETAIL,
  TICKET_AMBULANCE,
  TICKET_ALERTS,
  ACTIVE_VEHICLE_BTN_CLICK,
  STATUS_BTN_VALUE,
  RTO_WISE_STATS,
  TICKET_PENALTY_STATS,
  TICKET_PENALTY_REVENUE_STATS,
  TOP_PANIC_VEHICLES,
  EMERGENCY_DASHBOARD_STATS,
  TOP_PANIC_VEHICLES_DAILY,
  TOP_TAMPER_ALERTS,
  GET_SCHOOL_ROUTE_ASSET_GROUP_VEHICLE_STATS,
} from "../actions/dashboardTypes";

const initialState = {
  btnClick: false,
  refreshBtnClick: false,
  sosApiHit: false,
  inventoryData: [],
  ticketData: [],
  offlineIntimationStatsData: [],
  accountsData: [],
  accountStatsData: [],
  monthlyStatsData: [],
  vltdStatsData: [],
  vehicleTypeWiseData: [],
  emergencyStatsData: [],
  otherAlertsData: [],
  citizenStatsData: [],
  manufactureStatsData: [],
  bgDetailData: [],
  rtoStateIdData: [],
  rtoStatsData: [],
  vltdStatsDashBoardData: [],
  citizenUsersData: [],
  citizenUsersSosData: [],
  citizenUsersSosFilterData: [],
  getRoutefenceData: [],
  getRoutefenceFilterData: [],
  getAreaFenceData: [],
  monitorDashStatsData: [],
  monitorDashDetailData: [],
  sosProviderByLocationData: [],
  getTraumaCenters: [],
  getRtoRfcData: [],
  getEmergencyData: [],
  getEmergencyStats: [],
  getTicketAmbulanceData: [],
  getTicketAlertsData: [],
  setCitizenUsersAlertSosData: [],
  filterBtnClickVal: "overspeed",
  activeVehicleBtnClickVal: false,
  statusBtnClickVal: false,
  getSchoolRouteAssetGroupVehiclesStats: [],
};

const dashBoardReducersData = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case TOTAL_DEVICE_CLICK:
      return {
        ...state,
        btnClick: payload,
      };
    case REFRESH_BTN_MONITOR:
      return {
        ...state,
        refreshBtnClick: payload,
      };
    case FILTER_BTN_VALUE:
      return {
        ...state,
        filterBtnClickVal: payload,
      };
    case STATUS_BTN_VALUE:
      return {
        ...state,
        statusBtnClickVal: payload,
      };
    case ACTIVE_VEHICLE_BTN_CLICK:
      return {
        ...state,
        activeVehicleBtnClickVal: payload,
      };
    case CLEAR_SOS_API_HIT:
      return {
        ...state,
        sosApiHit: payload,
      };
    case INVENTORY_STATS:
      return {
        ...state,
        inventoryData: payload,
      };
    case TICKET_STATS:
      return {
        ...state,
        ticketData: payload,
      };
    case OFFLINE_INTIMATION_STATS:
      return {
        ...state,
        offlineIntimationStatsData: payload,
      };
    case GET_ACCOUNTS:
      return {
        ...state,
        accountsData: payload,
      };
    case VLTD_DAILY_STATS:
      return {
        ...state,
        accountStatsData: payload,
      };
    case VLTD_MONTHLY_STATS:
      return {
        ...state,
        monthlyStatsData: payload,
      };
    case VLTD_STATUS_STATS:
      return {
        ...state,
        vltdStatsData: payload,
      };
    case TOP_PANIC_VEHICLES:
      return {
        ...state,
        panicVehicleData: payload,
      };
    case TOP_PANIC_VEHICLES_DAILY:
      return {
        ...state,
        panicVehicleDailyData: payload,
      };
    case TOP_TAMPER_ALERTS:
      return {
        ...state,
        topTamperAlert: payload,
      };
    case VEHICLE_TYPE_WISE_STATS:
      return {
        ...state,
        vehicleTypeWiseData: payload,
      };
    case EMERGENCY_STATS:
      return {
        ...state,
        emergencyStatsData: payload,
      };
    case OTHER_ALERTS_STATS:
      return {
        ...state,
        otherAlertsData: payload,
      };
    case CITIZEN_STATS:
      return {
        ...state,
        citizenStatsData: payload,
      };
    case MANUFACTURE_STATS:
      return {
        ...state,
        manufactureStatsData: payload,
      };
    case TICKET_PENALTY_STATS:
      return {
        ...state,
        ticketPenlaltyStatsData: payload,
      };
    case TICKET_PENALTY_REVENUE_STATS:
      return {
        ...state,
        ticketPenlaltyRevenueStatsData: payload,
      };
    case BG_DETAIL_STATS:
      return {
        ...state,
        bgDetailData: payload,
      };
    case RTO_WISE_STATS:
      return {
        ...state,
        rtoWiseData: payload,
      };
    case RTO_STATEID_STATS:
      return {
        ...state,
        rtoStateIdData: payload,
      };
    case RTO_STATS:
      return {
        ...state,
        rtoStatsData: payload,
      };
    case VLTD_STATS_DASHBOARD:
      return {
        ...state,
        vltdStatsDashBoardData: payload,
      };
    case CITIZEN_USERS:
      return {
        ...state,
        citizenUsersData: payload,
      };
    case CITIZEN_USERS_SOS:
      return {
        ...state,
        citizenUsersSosData: payload,
      };
    case CITIZEN_ALERT_SOS:
      return {
        ...state,
        setCitizenUsersAlertSosData: payload,
      };
    case CITIZEN_USERS_SOS_FILTER:
      return {
        ...state,
        citizenUsersSosFilterData: payload,
      };
    case GET_ROUTEFENCE:
      return {
        ...state,
        getRoutefenceData: payload,
      };
    case GET_ROUTEFENCE_FILTER:
      return {
        ...state,
        getRoutefenceFilterData: payload,
      };
    case GET_AREAFENCE:
      return {
        ...state,
        getAreaFenceData: payload,
      };
    case MONITOR_DASHBOARD_STATS:
      return {
        ...state,
        monitorDashStatsData: payload,
      };
    case MONITOR_DASHBOARD_DETAIL:
      return {
        ...state,
        monitorDashDetailData: payload,
      };
    case SOS_PROVIDER_BY_LOCATION:
      return {
        ...state,
        sosProviderByLocationData: payload,
      };
    case LOCATE_TRAUMACENTER:
      return {
        ...state,
        getTraumaCenters: payload,
      };
    case GET_RTO_RFC:
      return {
        ...state,
        getRtoRfcData: payload,
      };
    case EMERGENCY_DASHBOARD_DETAIL:
      return {
        ...state,
        getEmergencyData: payload,
      };
    case EMERGENCY_DASHBOARD_STATS:
      return {
        ...state,
        getEmergencyStats: payload,
      };
    case TICKET_AMBULANCE:
      return {
        ...state,
        getTicketAmbulanceData: payload,
      };
    case TICKET_ALERTS:
      return {
        ...state,
        getTicketAlertsData: payload,
      };
    case GET_SCHOOL_ROUTE_ASSET_GROUP_VEHICLE_STATS:
      return {
        ...state,
        getSchoolRouteAssetGroupVehiclesStats: payload,
      };
    default:
      return state;
  }
};

export { dashBoardReducersData };
